module.exports = __webpack_public_path__ + "img/zzbjx.9ce49f59.jpg";